<template>
  <div class="flex flex-col justify-center">
    <h3 class="font-sans-serif mb-0 md:mb-2 text-sm md:text-xl
    flex justify-center">
      {{dayStart.date()}} / {{dayStart.month()+1}} / {{dayStart.year()}}
    </h3>
    <h3 class="font-sans-serif hidden md:block">
      {{ $t('masterclass.from') }} <strong>{{start}}</strong> {{ $t('masterclass.to') }}
      <strong>{{end}}</strong>
    </h3>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import DatesConversion from '@/mixins/DatesConversion';

export default {
  props: ['masterclass'],

  mixins: [DatesConversion],

  computed: {
    dayStart() {
      const date = (this.masterclass && this.masterclass.day)
        ? dayjs.tz(`${this.masterclass.day} ${this.masterclass.start}`, 'UTC') : '';
      return dayjs(date).tz(this.choosenTimezone);
    },
    start() {
      if (this.masterclass.start) {
        const timeStart = `${this.masterclass.day} ${this.masterclass.start}`;
        const start = this.convertDateInChoosenTimezone(timeStart);
        return `${start.hour()}:${start.minute() === 0 ? '00' : start.minute()}`;
      }
      return null;
    },
    end() {
      if (this.masterclass.end) {
        const timeEnd = `${this.masterclass.day} ${this.masterclass.end}`;
        const end = this.convertDateInChoosenTimezone(timeEnd);
        return `${end.hour()}:${end.minute() === 0 ? '00' : end.minute()}`;
      }
      return null;
    },
  },
};
</script>
